<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Harlan Estates</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con la crescente domanda per le aziende vinicole della Napa Valley in tutto il mondo, l'ascesa alla fama della California non è passata inosservata agli investitori di vini pregiati. L'analisi suggerisce che questo continuerà, quindi è giunto il momento di considerare l'aggiunta di alcuni dei marchi di punta della California nei nostri portafogli. Screaming Eagle, ovviamente, ruba le luci della ribalta per la costa occidentale, ma un secondo molto vicino sarebbe l'Harland Estate, con il suo eccellente California Cabernet Sauvignon.
                    </div>

                    <div class="howto-title2">Un principiante scommette su una prima crescita</div>
                    <div class="howto-text">
                        Con un mandato autoproclamato che avrebbe prodotto il primo vino di prima crescita californiano in
                        Napa, Bill Harlan nutriva grandi speranze per la sua proprietà. Fondata dall'uomo stesso nel 1984, Harlan
                        ha una visione di 200 anni per il suo vino, vale a dire creare un vino che abbia lo stesso onore e
                        prestigio come Mouton-Rothschild, ed essere dominante negli Stati Uniti come lo è il primo Bordeaux in crescita
                        in Francia. E dove Harlan ha scelto di gettare le fondamenta della sua eredità? In un minuscolo 6 acri
                        appezzamento di terreno sottosviluppato a Meadowwood. Una scelta rischiosa per alcuni ma da ex professionista
                        giocatore d'azzardo, Harlan sapeva che era giunto il momento di mettere le carte in tavola.
                    </div>

                    <div class="howto-title2">Costruire il suo sogno di due secoli acino dopo acino</div>
                    <div class="howto-text">
                        Oggi il vigneto comprende 36 acri e dopo quasi tre decenni ha prodotto alcuni dei
                        il Cabernet Sauvignon più sorprendente della costa occidentale. Combinando sistematicamente trame eleganti
                        con freschezza e complessità, il gusto audace di Harlan ha raggiunto il successo globale. L'esportazione
                        mercato è ampio e variegato, con almeno 45 paesi e oltre. Inoltre, Robert Parker
                        è un fan - ha assegnato il suo punteggio perfetto di 100 punti ad almeno cinque annate che non lo hanno fatto
                        vendite danneggiate. Il figlio di Harlan si è recentemente unito al lato produttivo delle cose, il che significa che il
                        futuro è assicurato, forse non per i prossimi due secoli, ma per almeno altri 50 anni circa.
                    </div>

                    <div class="howto-title2">Incredibilmente diverso</div>
                    <div class="howto-text">
                        Venduto direttamente ai clienti, Harlan costa circa un quarto del suo principale rivale Screaming
                        Eagle ma è ancora il secondo vino più costoso della regione. Bassa produzione di 2.000 casse
                        significa che Harlan è uno dei preferiti nelle aste, con bottiglie che superano i 700 € per il massimo
                        annate. Harlan vende anche futures, quasi inaudito negli Stati Uniti, quindi la sua storia d'amore con
                        Bordeaux è autentico come viene.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Harlan Estates</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Da die Nachfrage nach Weingütern im Napa Valley weltweit wächst, ist Kaliforniens Aufstieg zum Ruhm von Investoren für erlesene Weine nicht unbemerkt geblieben. Analysen deuten darauf hin, dass dies so weitergehen wird. Daher ist es höchste Zeit, darüber nachzudenken, einige der angesagten Marken Kaliforniens in unser Portfolio aufzunehmen. Screaming Eagle stiehlt der Westküste natürlich das Rampenlicht, aber ganz knapp dahinter wäre das Harland Estate mit seinem hervorragenden kalifornischen Cabernet Sauvignon.
                    </div>

                    <div class="howto-title2">Ein Anfänger setzt auf ein erstes Wachstum</div>
                    <div class="howto-text">
                        Mit dem selbsternannten Auftrag, den ersten kalifornischen Spitzenwein zu produzieren
                        Napa, Bill Harlan hatte große Hoffnungen in sein Eigentum. 1984 von Harlan selbst gegründet
                        hat eine 200-jährige Vision für seinen Wein, nämlich einen Wein zu schaffen, der die gleiche Ehre hat und
                        Prestige wie Mouton-Rothschild und in den USA ebenso dominierend sein wie das erste Wachstum Bordeaux
                        in Frankreich. Und wo hat Harlan den Grundstein für sein Vermächtnis gelegt? Auf einer winzigen Fläche von 6 Hektar
                        Grundstück mit unbebautem Grundstück in Meadowwood. Für manche aber als Ex-Profi eine riskante Entscheidung
                        Als Spieler wusste Harlan, dass es an der Zeit war, seine Karten auf den Tisch zu legen.
                    </div>

                    <div class="howto-title2">Traube für Traube seinen Zwei-Jahrhundert-Traum aufbauen</div>
                    <div class="howto-text">
                        Heute umfasst der Weinberg 36 Hektar und hat nach fast drei Jahrzehnten einen Teil davon hervorgebracht
                        der schönste Cabernet Sauvignon an der Westküste. Elegante Texturen systematisch kombinieren
                        Mit seiner Frische und Komplexität hat Harlans kühner Geschmack weltweiten Erfolg erzielt. Der Export
                        Der Markt ist breit und vielfältig und umfasst mindestens 45 Länder, Tendenz steigend. Außerdem Robert Parker
                        ist ein Fan – er hat seine perfekte 100-Punkte-Bewertung an mindestens fünf Jahrgänge vergeben, die dies nicht getan haben
                        schadet dem Umsatz. Harlans Sohn hat sich kürzlich der Produktionsseite angeschlossen, was bedeutet, dass
                        Die Zukunft ist gesichert, vielleicht nicht für die nächsten zwei Jahrhunderte, aber für mindestens weitere 50 Jahre.
                    </div>

                    <div class="howto-title2">Toll anders</div>
                    <div class="howto-text">
                        Harlan wird direkt an Kunden verkauft und kostet etwa ein Viertel des Preises seines Hauptkonkurrenten Screaming
                        Eagle ist aber immer noch der zweitteuerste Wein der Region. Geringe Produktion von 2.000 Kisten
                        Das bedeutet, dass Harlan ein Favorit auf Auktionen ist, wobei die Spitzenflaschen über 700 € erzielen
                        Jahrgänge. Harlan verkauft sogar Futures – in den USA fast unbekannt, daher seine Liebesaffäre mit
                        Bordeaux ist so authentisch wie es nur sein kann.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Domaines d'Harlan</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec une demande croissante pour les établissements vinicoles de Napa Valley dans le monde entier, la montée en puissance de la Californie n'est pas passée inaperçue auprès des investisseurs en vins fins. L'analyse suggère que cela va continuer, il est donc grand temps d'envisager d'ajouter certaines des marques à la mode de la Californie dans nos portefeuilles. Screaming Eagle, bien sûr, vole la vedette de la côte ouest, mais un deuxième très proche serait le domaine Harland, avec son excellent cabernet sauvignon californien.
                    </div>

                    <div class="howto-title2">Un débutant mise sur un premier cru</div>
                    <div class="howto-text">
                        Avec la mission autoproclamée de produire le premier vin de premier cru californien en
                        Napa, Bill Harlan avait de grands espoirs pour sa propriété. Fondée par l'homme lui-même en 1984, Harlan
                        a une vision de 200 ans pour son vin, à savoir créer un vin qui a le même honneur et
                        prestige que Mouton-Rothschild, et être aussi dominant aux États-Unis que le premier cru classé de Bordeaux
                        en France. Et où Harlan a-t-il choisi de jeter les bases de son héritage ? Dans un petit 6 acres
                        parcelle de terrain sous-développé à Meadowwood. Un choix risqué pour certains mais en tant qu'ex-professionnel
                        joueur, Harlan savait qu'il était temps de jouer cartes sur table.
                    </div>

                    <div class="howto-title2">Construire son rêve de deux siècles, raisin par raisin</div>
                    <div class="howto-text">
                        Aujourd'hui, le vignoble s'étend sur 36 acres et, après près de trois décennies, a produit certains des
                        le plus beau cabernet sauvignon de la côte ouest. Associer systématiquement des textures élégantes
                        avec fraîcheur et complexité, le goût audacieux de Harlan a remporté un succès mondial. L'exportation
                        Le marché est large et varié, avec au moins 45 pays et plus encore. De plus, Robert Parker
                        est un fan - il a attribué sa note parfaite de 100 points à au moins cinq millésimes qui n'ont pas
                        nuire aux ventes. Le fils de Harlan a récemment rejoint le côté producteur des choses, ce qui signifie que le
                        l'avenir est assuré, peut-être pas pour les deux siècles à venir, mais pour une cinquantaine d'années au moins.
                    </div>

                    <div class="howto-title2">Incroyablement différent</div>
                    <div class="howto-text">
                        Vendu directement aux clients, Harlan coûte environ le quart du prix de son principal rival Screaming
                        Eagle mais se classe toujours comme le deuxième vin le plus cher de la région. Faible production de 2 000 caisses
                        signifie que Harlan est l'un des favoris des ventes aux enchères, avec des bouteilles à plus de 700€ pour le sommet
                        millésimes. Harlan vend même aussi des contrats à terme - presque sans précédent aux États-Unis, donc son histoire d'amour avec
                        Bordeaux est aussi authentique que possible.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Harlan Estates</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With demand growing for Napa Valley wineries worldwide, California’s rise to fame has not gone unnoticed by fine wine investors. Analysis suggests that this will continue, so it is high time we consider adding some of California’s buzz brands in our portfolios. Screaming Eagle, of course, steals the limelight for the west coast, but a very close second would be the Harland Estate, with its excellent California Cabernet Sauvignon.
                    </div>

                    <div class="howto-title2">A first timer gambles on a first growth</div>
                    <div class="howto-text">
                        With a self-proclaimed remit that he would produce the first Californian first growth wine in
                        Napa, Bill Harlan had high hopes for his property. Founded by the man himself in 1984, Harlan
                        has a 200-year vision for his wine, namely to create a wine that has the same honour and
                        prestige as Mouton-Rothschild, and be as commanding in the USA as the first growth Bordeaux is
                        in France. And where did Harlan choose to lay the foundations of his legacy? In a tiny 6-acre
                        plot of underdeveloped land in Meadowwood. A risky choice for some but as an ex-professional
                        gambler, Harlan knew that it was time to lay his cards on the table.
                    </div>

                    <div class="howto-title2">Building his two-century dream grape by grape</div>
                    <div class="howto-text">
                        Today the vineyard encompasses 36-acres, and after nearly three decades has produced some of the
                        most stunning Cabernet Sauvignon on the west coast. Systematically combining elegant textures
                        with freshness and complexity, Harlan’s bold taste has achieved global success. The export
                        market is wide and varied, with at least 45 countries and counting. Additionally, Robert Parker
                        is a fan – he has awarded his perfect 100-point score to at least five vintages which have not
                        hurt sales. Harlan’s son has recently joined the producing side of things, which means that the
                        future is assured, perhaps not for the next two centuries, but another 50 or so years at least.
                    </div>

                    <div class="howto-title2">Screamingly different</div>
                    <div class="howto-text">
                        Sold directly to customers, Harlan is about a quarter of the price of its main rival Screaming
                        Eagle but still ranks as the region’s second most expensive wine. Low production of 2,000 cases
                        means that Harlan is a favourite at auctions, with bottles fetching over €700 for the top
                        vintages. Harlan even sells futures too – almost unheard of in the US, so his love affair with
                        Bordeaux is as authentic as they come.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HarlanEstates",
    head: {
        title: 'Harlan Estates | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the world-renowned luxury wine from Harlan Estates, a Napa Valley based winery producing exceptional, limited production red wines. Experience the unique terroir and expertise of our winemakers today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
